import { type JSX } from 'react/jsx-runtime';

import { createRender, type RenderProps } from './types';

import { ServiceCollectionRecruitmentBanner } from '../../../components/ServiceCollectionRecruitmentBanner';

export const render: (renderProps: RenderProps) => JSX.Element | null = createRender(
	({ onDismissed, siteAddress }) => (
		<ServiceCollectionRecruitmentBanner onDismissed={onDismissed} siteAddress={siteAddress} />
	),
);

export default render;
